// Global Styles
const GLOBALSTYLES = {
  colors: {
    primary: "#ffffff",
    secondary: "#6c757d",
    link: "#60A5FA",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    info: "#17a2b8",
    light: "#f8f9fa",
    dark: "#343a40",
    white: "#ffffff",
    black: "#000000",
    background: "#0f0f0f",
    secondaryBackground: "#2C2C2C",
  },

  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },

  typography: {
    fontFamily: "'Quicksand', sans-serif",
    fontSizeBase: "16px",
    fontSizeLarge: "28px",
    fontSizeExtraLarge: "40px",
    fontSizeSmall: "12px",
    fontWeightNormal: "400",
    fontWeightBold: "700",
  },
};

export default GLOBALSTYLES;
